// Tipos


export interface Consumer {
  uid: string;
  first_name: string;
  last_name: string;
  email: string;
  burned_coupons: number;
  last_burned_coupon: string | null;
  enabled: boolean;
  client_name: string;
}


// Obtener lista de consumidores
export const getConsumers = async (): Promise<Consumer[]> => {
  const TOKEN = 'FeMsA@2024';
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://club-coca-cola-api.vercel.app/api/v1/back';
  try {
    console.log('Iniciando llamada a la API de consumidores...');
    const apiUrl = `${API_BASE_URL}/consumers`;
    console.log('URL de la API:', apiUrl);
    
    const token = localStorage.getItem('token');
    console.log('Token de autenticación:', token ? 'presente' : 'ausente');
    
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`
      }
    });

    console.log('Respuesta de la API - Status:', response.status);
    
    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error en la respuesta de la API:', errorText);
      throw new Error(`Error al obtener los consumidores: ${response.status} ${response.statusText}`);
    }

    const data = await response.json();
    console.log('Datos recibidos de la API:', data);
    return data;
  } catch (error) {
    console.error('Error al obtener consumidores:', error);
    // En caso de error, devolver los datos de ejemplo
    return [];
  }
};

// Actualizar estado de un consumidor
export interface ConsumerTransaction {
  date: string;
  coupon: string;
  promo_code: string;
  client_id: number;
  client_name: string;
}

export const getConsumerTransactions = async (consumerId: string): Promise<ConsumerTransaction[]> => {
  const TOKEN = 'FeMsA@2024';
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://club-coca-cola-api.vercel.app/api/v1/back';
  try {
    const response = await fetch(`${API_BASE_URL}/consumers/transactions/${consumerId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`
      }
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Error en la respuesta de la API de transacciones:', errorText);
      throw new Error(`Error al obtener las transacciones: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error al obtener transacciones del consumidor:', error);
    throw error;
  }
};

export const updateConsumerStatus = async (consumer_id: string, disabled: boolean): Promise<boolean> => {
  const TOKEN = 'FeMsA@2024';
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://club-coca-cola-api.vercel.app/api/v1/back';
  try {
    const response = await fetch(`${API_BASE_URL}/consumers/change_status`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${TOKEN}`
      },
      body: JSON.stringify({ 
        consumer_id,
        disabled
      })
    });

    if (!response.ok) {
      throw new Error('Error al actualizar el estado del consumidor');
    }

    return true;
  } catch (error) {
    console.error('Error al actualizar el estado del consumidor:', error);
    throw error;
  }
};
